import { Injectable, Input } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { ChatService } from './chat.service';
import { ToastController } from '@ionic/angular';
import { translatable } from '../utils/translateables';
import { ErrorHandlerService } from './error-handler.service';
import { map, Observable } from 'rxjs';
import { Config } from '../config';

@Injectable({
  providedIn: 'root',
})
export class ShippingService {
  constructor(
    private http: HttpClient,
    private chatService: ChatService,
    private translate: TranslateService,
    private errorService: ErrorHandlerService,
    private toastController: ToastController,
  ) {}

sendOrderToCloud(
  userId: number,
  productId: number,
  offered_product_id: number,
  userType: string,
  shippingType: string,
  saveAddress: number,
  details: any,
): Observable<any> {
  const payload = {
    sender_id: userId,
    product_id: productId,
    offered_product_id: offered_product_id,
    type: userType,
    shipping_type: shippingType === 'pickup' ? 'Pickup' : 'Delivery',
    save_address: saveAddress,
    details: details || {}
  };

  return this.http.post(`${Config.apiUrl}/shipping/save-shipping-detail`, payload);
}

confirmOrder(
  userId: number,
  productId: number,
  orderStatus: number
): Observable<any> {
  const payload = {
    sender_id: userId,
    product_id: productId,
    order_status: orderStatus
  };

  return this.http.post(`${Config.apiUrl}/shipping/confirm-order`, payload);
}

generateLabel(productId: number, buyerId: number): Observable<Blob> {
  const payload = { product_id: productId, buyer_id: buyerId };

  return this.http.post(`${Config.apiUrl}/shipping/shipment-label`, payload, {
    responseType: 'arraybuffer', // true binary
    observe: 'body'
  }).pipe(
    map((buffer: ArrayBuffer) => {
      // ✅ Convert to Blob
      return new Blob([buffer], { type: 'application/pdf' });
    })
  );
}

getSignedLabelUrl(productId: number, buyerId: number): Observable<{ status: string; url?: string; message?: string }> {
  const payload = { product_id: productId, buyer_id: buyerId };

  return this.http.post<{ status: string; url?: string; message?: string }>(
    `${Config.apiUrl}/shipping/shipment-label/signed-url`,
    payload
  );
}


private async showToast(message: string) {
  const toast = await this.toastController.create({
    message,
    duration: 3000,
    position: 'bottom',
    color: 'success',
  });
  await toast.present();
}

getShippingData(type: string, sender_id: number, product_id: number, offered_product_id: number): Observable<any> {
  const payload = { type, sender_id, product_id, offered_product_id };
  return this.http.post(`${Config.apiUrl}/shipping/check-shipping-detail`, payload);
}
getSavedShippingAddress(id: number): Observable<any> {
  const url = `${Config.apiUrl}/shipping/get-saved-shipping-details/${id}`;
  return this.http.get(url);
}

getShippingMethods() {
  return this.http.get<{ shipping_methods: any[] }>(`${Config.apiUrl}/shipping/shipping-methods`);
}

}
